const firstFields = [
  {
    propertyName: "positionDuties",
    labelId: "jobDescriptionRequestEdit.positionDuties",
  },
  {
    propertyName: "responsibilities",
    labelId: "jobDescriptionRequestEdit.responsibilities",
  },
  {
    propertyName: "compulsoryQualificationRequirements",
    labelId: "jobDescriptionRequestEdit.compulsoryQualificationRequirements",
  },
  {
    propertyName: "basicInteractionsAtWork",
    labelId: "jobDescriptionRequestEdit.renderBasicInteractions",
  },
];

const secondFields = [
  {
    propertyName: "positionDuties",
    labelId: "jobDescriptionRequestEdit.positionDuties",
  },
  {
    propertyName: "objectivePosition",
    labelId: "jobDescriptionRequestEdit.objectivePosition",
  },
  {
    propertyName: "generalAdditionalRequirements",
    labelId: "jobDescriptionRequestEdit.generalAdditionalRequirements",
  },
  {
    propertyName: "basicInteractionsAtWork",
    labelId: "jobDescriptionRequestEdit.basicInteractionsAtWork",
  },
];

export const jobDescriptionFields = {
  first: firstFields,
  second: secondFields,
};
